module.exports = __webpack_public_path__ + "img/form_horizontal_layout_1.32c5eb07.png";